/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Organization page
  Date: April 04, 2020
**/

import React, { useEffect, useState } from 'react';
import { Grid, Tooltip, IconButton } from '@material-ui/core';
import moment from 'moment';
// import EditIcon from '@material-ui/icons/Edit';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { useStoreState, useStoreActions } from 'easy-peasy';
import styles from './organization.module.scss';
import BlockIcon from '@material-ui/icons/Block';
import {
  globalPageTypeEntity,
  currentUserEntity,
} from '../../constants/applicationConstants';
// import { dateFormat } from '../../utils/common';
// import SyncAltIcon from '@material-ui/icons/SyncAlt';
import ArchiveIcon from '@material-ui/icons/Archive';
// import Chip from '@material-ui/core/Chip';
// import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
// import AlarmIcon from '@material-ui/icons/Alarm';
// import SingleSelectFilter from '../../components/enhancedTable/filters/SingleSelectFilter';
// import CustomInputFilter from '../../components/enhancedTable/filters/CustomInputFilter';
import DisplayBreadcrumbs from '../../components/displayBreadcrumbs/displayBreadcrumbs';
import FilterSection from '../../components/filterSections/FilterSection';
import CustomListing from '../../components/customListing/CustomListing';
import { GLOBAL_ENITY, PopupModal , sortByField} from '../../submodule';
import { OrganizationForm } from './organizationForm';
import { stringConstants } from '../../constants/stringConstants';


const OrganizationPage = (props) => {
  // const { userModulePermissions } = useCommonAuth();
  const [filteredData, setFlteredData] = useState({
    status: 'ALL',
    name: '',
  });

  function resetFilters() {
    setFlteredData({
      status: 'ALL',
      name: '',
    })
  }


  const searchByKeyworld = (key, value) => {
    setFlteredData({ ...filteredData, [key]: value });
  };
  const filterList = [
    {
      type: 'droupdown',
      title: 'Status',
      value: filteredData.status,
      onChange: searchByKeyworld,
      searchKey: 'status',
      list: ['ALL', 'DRAFT', 'APPROVED'],
    },
  ];

  const [orgAction] = useStoreActions((actions) => [actions.organization]);
  const commonAction = useStoreActions((actions) => actions.common);

  const [orgState, userRole, moduleAccessPermissions] = useStoreState(
    (state) => [
      state.organization,
      state.login.userInfo,
      state.login.moduleAccessPermissions,
    ],
  );
  const [tableData, setTableData] = React.useState(false);
  

  // const skipPageReset = false;
  const [, setShowModal] = useState(false);
  const [, setChangeIndex] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const breadcrumbsNav = [
    {
      title: 'Tenants',
      link: '/organization',
    },
  ];
  
  useEffect(() => {
    orgAction.setOrgsListLoader(true);
    orgAction.getOrgsList();
    orgAction.setOrgs({});
    orgAction.setAddedOrganizationId('');
  }, []);
  useEffect(() => {
    
    let newTableData = [...orgState.orgsList];
    newTableData = newTableData.filter((data) => {
      return (
        (data.current_status == filteredData.status ||
          filteredData.status == 'ALL') &&
        (filteredData.name == '' ||
          data.title
            .toLocaleLowerCase()
            .match(filteredData.name.toLocaleLowerCase()) ||
          data.shortname
            .toLocaleLowerCase()
            .match(filteredData.name.toLocaleLowerCase()))
      );
    });
    newTableData = sortByField({
      data: newTableData,
      key: 'modify_date',
      secondKey: 'create_date',
    });
    setTableData(newTableData);
  }, [orgState.orgsList, filteredData]);


  useEffect(() => {
    if (userRole.roles) {
      let userTitle = userRole.roles.title.toLowerCase();
      if (
        userTitle != currentUserEntity.platformAdminTitle &&
        userTitle != currentUserEntity.platformOperator
      ) {
        props.history.push('/');
      }
    }
  }, [userRole]);
  function handleInlineStatusChange(item) {
    try {
      let reqData = {
        PK: item.PK,
        SK: item.PK,
        current_status: item.current_status,
      };

      orgAction
        .updateTenantStatus(reqData)
        .then(function (response) {
          // Now need to update the status in data
          let updatedData = tableData.map((item) => {
            if (item.PK == reqData.PK) {
              item.current_status = reqData.current_status;
              item.modify_date = moment();
            }
            return item;
          });
          updatedData = sortByField({
            data: updatedData,
            key: 'modify_date',
            secondKey: 'create_date',
          });
          setTableData(updatedData);

          commonAction.setSubmitSnackbar({
            status: true,
            messages: stringConstants.updateMsg,
          });
        })
        .catch(function (error) {

          if (
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            commonAction.setSubmitSnackbar({
              status: true,
              messages: error.response.data.error,
              error: true,
            });
          }
        });
    } catch (err) {
      console.error(err);
    }
  }
  return (
    <Grid container direction="row">
      <DisplayBreadcrumbs items={breadcrumbsNav} />
      <Grid container direction="row" style={{ marginBottom: '50px' }}>
        <Grid container>
          <Grid item md={12} className={styles.filterContainer}>
            <Grid container>
              <Grid item md={4} style={{ display: 'flex' }}>
                Tenants &nbsp;&nbsp;
              </Grid>

              <FilterSection
                filterList={filterList}
                keywordsPlaceholder="Enter Name"
                keywordskey="name"
                keywordsValue={filteredData.name}
                handleKeywordsChange={searchByKeyworld}
                resetFilters={resetFilters}
              />

              <Grid
                item
                md={4}
                justifyContent="flex-end"
                style={{ display: 'flex' }}
              >
                <Tooltip title="Add New">
                  <IconButton
                    color="primary"
                    aria-label="Add"
                    onClick={() => setIsModalOpen(true)}
                  >
                    <AddBoxIcon />
                  </IconButton>
                </Tooltip>
                {false && (<Tooltip title="Disable">
                  <span>
                    <IconButton
                      onClick={() =>
                        activeDeactivateHandler(
                          event,
                          selectedItems,
                          globalPageTypeEntity.deactivate,
                        )
                      }
                      color="primary"
                      disabled={
                        !moduleAccessPermissions.businesslines.some((item) => {
                          return item === 'disable';
                        }) ||
                        selectedItems === null ||
                        (selectedItems && selectedItems.length === 0)
                      }
                    >
                      <BlockIcon />
                    </IconButton>
                  </span>
                </Tooltip>)}

                {false && (<Tooltip title="Archive" disabled>
                  <IconButton>
                    <ArchiveIcon />
                  </IconButton>
                </Tooltip>)}
              </Grid>
            </Grid>
          </Grid>


          <CustomListing
            tableData={tableData}
            isLoaded={false}
            entityType={GLOBAL_ENITY.organization}
            handleInlineStatusChange={handleInlineStatusChange}
            setShowModal={setShowModal}
            setChangeIndex={setChangeIndex}
          />
          <PopupModal open={isModalOpen}>
              <OrganizationForm onClose={()=>{
                setIsModalOpen(false)
                }}
              />
          </PopupModal>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OrganizationPage;
